<template>
  <div class="table-wrap">
    <div class="filter-wrap">
      <div class="header-top">
        <ul class="menu-list">
          <li :class="['menu-item', curComponent === 'AccountTable' ? 'cur' : '']" @click="changeTable('AccountTable')">投放账号</li>
          <li :class="['menu-item', curComponent === 'ProjectTable' ? 'cur' : '']" @click="changeTable('ProjectTable')">项目</li>
          <li :class="['menu-item', curComponent === 'AdvertiseTable' ? 'cur' : '']" @click="changeTable('AdvertiseTable')">广告</li>
        </ul>

        <el-button class="add-plan" icon="el-icon-plus" type="primary" @click="addPlan">创建广告</el-button>
      </div>
    </div>
    <div class="content-wrap">
      <keep-alive>
        <component @checkTable="checkTable" ref="curTableRef" v-bind:is="curComponent"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import AccountTable from "./accountTable";
import ProjectTable from "./projectTable";
import AdvertiseTable from "./advertiseTable";
export default {
  components: {
    AccountTable,
    ProjectTable,
    AdvertiseTable,
  },
  data() {
    return {
      curComponent: "AccountTable",
    };
  },
  methods: {
    addPlan() {
      this.$router.push("/promotion-ttV2.html/plan");
    },
    changeTable(componentName, data) {
      if (this.curComponent !== componentName) {
        this.curComponent = componentName;
        this.$nextTick(() => {
          //有没有data时查询全部
          this.$refs.curTableRef.clickSearch(data);
        });
      }
    },
    checkTable({ name, data }) {
      this.changeTable(name, data);
    },
  },
};
</script>

<style lang="less" scoped>
.table-wrap {
  // width: calc(100vw - 183px);
  // width: 500px;
  .filter-wrap {
    margin: 16px 16px 0px 16px;
    background-color: #fff;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    user-select: none;
    .header-top {
      display: flex;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      padding-right: 25px;
      justify-content: space-between;
      .menu-list {
        margin: 0px;
        padding: 0px 0px 0px 25px;
        list-style: none;
        display: flex;
        .menu-item {
          height: 44px;
          line-height: 44px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          margin-right: 41px;
          border-bottom: 2px solid transparent;
          box-sizing: border-box;
          cursor: pointer;
          &:hover {
            color: rgba(24, 144, 255, 1);
          }
          &.cur {
            color: rgba(24, 144, 255, 1);
            border-bottom: 2px solid rgba(24, 144, 255, 1);
          }
        }
      }
      .add-plan {
        height: 28px;
        margin-top: 8px;
      }
    }
  }
  .content-wrap {
    margin: 0 16px;
  }
}
</style>
